import V1 from '@/system-modules/share/v1/SysShareV1'
import { ISysShareModule } from '@/contracts/system-modules/share/ISysShareModule'
import { Provider } from '@/contracts/core/provider/entity/Provider'
import SystemModuleConfig from '@/contracts/system/configs/SystemModuleConfig'

export class SysShareProvider extends Provider<ISysShareModule> {
  realizations: Record<string, ISysShareModule> = {
    v1: V1(),
  }
}

const instance: { module: ISysShareModule | null } = { module: null }

export function SysShareProviderModule(): ISysShareModule {
  const version = SystemModuleConfig.getShareVersion()

  if (!instance.module) {
    instance.module = new SysShareProvider().module(version)
  }

  return instance.module
}
